<div class="input-container">
  <div
    class="input-value-container "
    ngClass="{{ !validValue ? 'input-value-container--invalid' : '' }}"
  >
    <input
      class="input-value"
      [(ngModel)]="actualValue"
      readonly="true"
    >
    <div class="input-units" >
      <div class="input-units">
        {{ displayUnits }}
      </div>
    </div>
  </div>
</div>